import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import {
	BuildingImage,
	Container,
	Info,
	InfoBit,
	BiggerText,
	SmallerText,
	Name
} from './styles';

const Tile = props => {
	const { t, language, building } = props;

	const area = building.area ? `${building.area} m²` : null;
	const name = building.i18n[language].name

	const areaComponent = <BiggerText>{area}</BiggerText>;
	const nameComponent = name !== '' ? <Name>{name}</Name> : null;
	const contacts = building.mappedContacts.map(person => <SmallerText key={person.id}>{person.name}</SmallerText>);

	return (
		<React.Fragment>
			<BuildingImage style={{ backgroundImage: `url(${props.image })`}} />
			{props.star}
			<Container>
				<Info>
					{nameComponent}
					<InfoBit>
						<BiggerText>{building.address}</BiggerText>
						<SmallerText style={{ fontSize: '16px', marginBottom: '4px' }}>{building.city}</SmallerText>
						{contacts}
					</InfoBit>
					<InfoBit align="right">
						{areaComponent}
						{
							building.spaces.length > 0 &&
						<SmallerText>{t('browse/Building/Tile/Space count', { count: building.spaces.length })}</SmallerText>
						}
					</InfoBit>
				</Info>
			</Container>
		</React.Fragment>
	)
};

Tile.propTypes = {
	t: PropTypes.func,
	building: PropTypes.object,
	star: PropTypes.element,
	image: PropTypes.string,
	language: PropTypes.oneOf(['fi','en']),
}

export default translate('translations')(Tile);
